import { useState } from 'react';
import { useCandidatesResultsContext } from '../../../../Contexts/CandidateResultsContext';
import { CriteriaScoreFormValues } from '../CriteriaScore';
import CriteriaRow from './CriteriaRow';
import CriteriaScoreFormDialog from './CriteriaScoreFormDialog';
import { useNotificationContext } from '@/Context/NotificationContext';
import { ExperienceCriterionFinalScore } from '@/Models/ExperienceCriterionFinalScore';

const CriteriaList = () => {
    const { results, updateUserDefinedCriteriaScore } = useCandidatesResultsContext();
    const [open, setOpen] = useState(false);
    const [criteriaScoreToEdit, setCriteriaScoreToEdit] = useState<ExperienceCriterionFinalScore | undefined>();
    const { showFailToaster } = useNotificationContext();

    const handleEdit = (criterionScoreToEdit: ExperienceCriterionFinalScore) => {
        setCriteriaScoreToEdit(criterionScoreToEdit);
        setOpen(true);
    };

    const handleSubmit = async (newScore: CriteriaScoreFormValues, criterionScore: ExperienceCriterionFinalScore) => {
        try {
            await updateUserDefinedCriteriaScore(
                newScore.userDefinedScore,
                newScore.userDefinedJustification,
                criterionScore,
            );
            setOpen(false);
        } catch {
            showFailToaster();
        }
    };

    return (
        <>
            <div className="divide-border flex flex-col divide-y">
                {results.experienceCriteriaScore?.criteriaScores.map((criteriaScore, i) => (
                    <CriteriaRow
                        key={criteriaScore.experienceCriteriaId}
                        criterionFinalScore={criteriaScore}
                        index={i}
                        onEdit={handleEdit}
                    />
                ))}
            </div>
            <CriteriaScoreFormDialog
                open={open}
                criteriaFinalScore={criteriaScoreToEdit!}
                onSubmit={handleSubmit}
                onClose={() => setOpen(false)}
            />
        </>
    );
};

export default CriteriaList;
